// extracted by mini-css-extract-plugin
export default {"userContainer":"User_userContainer__Somsq","photoUrl":"User_photoUrl__AF47D"};